<template>
  <div class="upload-img">
    <div
      class="upload-img__item upload-img__preview"
      v-for="(url, index) in value"
      :key="index"
      @click="handlePreview(url)"
    >
      <img
        class="upload-img__image"
        alt=""
        :src="url"
      />
      <div class="upload-img__remove" @click.stop="handleRemove(index)" />
    </div>
    <div
      v-if="value.length < 3"
      class="upload-img__item upload-img__add"
      @click="handleAdd"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    }
  },

  methods: {
    handlePreview(current) {
      this.$wechat.wx.previewImage({
        current,
        urls: this.value
      })
    },

    handleRemove(index) {
      const value = [...this.value]
      value.splice(index, 1)
      this.$emit('input', value)
    },

    handleAdd() {
      this.$wechat.wx.chooseImage({
        count: 3 - this.value.length,
        sizeType: ['original', 'compressed'],
        sourceType: ['album', 'camera'],
        success: (res) => {
          this.$emit('input', this.value.concat(res.localIds))
          res.localIds.forEach((id) => this.uploadImage(id))
        }
      })
    }
  }
}
</script>

<style lang="less">
  .upload-img {
    display: flex;
  }

  .upload-img__item {
    position: relative;
    width: 2.667rem;
    height: 1.773rem;
    box-sizing: border-box;
    &:not(:last-child) {
      margin-right: 0.5rem;
    }
  }

  .upload-img__remove {
    position: absolute;
    top: -0.25rem;
    right: -0.25rem;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    transform: rotate(45deg);
    background: rgba(0, 0, 0, .7);
    &:active {
      opacity: .8;
    }
    &:before, &:after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      background-color: #fff;
    }
    &:before {
      width: 1px;
      height: 0.2rem;
    }
    &:after {
      width: 0.2rem;
      height: 1px;
    }
  }

  .upload-img__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0.04rem;
  }
  .upload-img__add {
    border: 1px solid #bec2cf;
    border-radius: 0.04rem;
    &:before, &:after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      background: #1890ff;
    }
    &:before {
      width: 1px;
      height: 0.507rem;
    }
    &:after {
      width: 0.507rem;
      height: 1px;
    }
  }
</style>
